import { Button } from '@heroui/react';
import { MdError } from 'react-icons/md';

interface ErrorMessageProps {
    subtitle: string;
    handleClick?: () => void;
    textButton?: string;
}

const ErrorMessageComponent = ({ subtitle, textButton, handleClick }: ErrorMessageProps) => {
    return (
        <div className="flex flex-col items-center justify-center pt-2.5 animate-fade-in">
            <MdError className="text-[150px] text-[#e64a3b]" />
            <p className="py-4 text-center text-lg font-medium">Error.</p>
            <p className="pb-4 text-center text-sm text-[#757575]">{subtitle}</p>
            {handleClick && (
                <Button color="primary" onPress={handleClick}>
                    {textButton ?? 'INICIO'}
                </Button>
            )}
        </div>
    );
};

export default ErrorMessageComponent;
